import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Button from "../../../../components/ui/Button";
import Text from "../../../../components/ui/Text";

export const HowAddPlayerDialog = ({
  isOpen,
  onClose,
  handleInviteExistingMember,
  handleAddManually,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { borderRadius: "12px", m: 2, width: "310px" } },
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 1 }}>
        <Text variant="pageHeader" sx={{ mb: 0, fontSize: "20px" }}>
          Add Player
        </Text>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Text
          component="p"
          variant="paragraph"
          sx={{ fontSize: "16px", lineHeight: 1.5, mb: 2 }}
        >
          How would you like to add this player?
        </Text>

        <Button onClick={handleInviteExistingMember} sx={{ mb: 0.5 }}>
          Invite existing member
        </Button>
        <Text
          component="p"
          variant="paragraph"
          sx={{ fontSize: "13px", lineHeight: 1.2, color: "#A1A1A1", mb: 2 }}
        >
          Sends them an invite to confirm and pay for their spot.
        </Text>

        <Button onClick={handleAddManually} sx={{ mb: 0.5 }}>
          Add manually
        </Button>
        <Text
          component="p"
          variant="paragraph"
          sx={{ fontSize: "13px", lineHeight: 1.2, color: "#A1A1A1", mb: 2 }}
        >
          Adds the name only — no invite or payment required.
        </Text>

        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
};
